// extracted by mini-css-extract-plugin
export var linkButton = "common-components-module--link-button--C8WCv";
export var linkButtonLight = "common-components-module--link-button-light--BcTpJ";
export var contactInput = "common-components-module--contact-input--y2Fc9";
export var inputWarning = "common-components-module--inputWarning--K26ix";